<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 style="color: #101010;line-height: 31px;" class="mb-0">
        {{ $l('table_label_already_permission_role') || '全部权限角色' }}
      </h6>
      <el-button type="danger" size="mini" plain @click="clear()">
        {{ $l('table_label_remove_role') || '移除角色' }}
      </el-button>
    </div>
    <vxe-grid
      ref="table"
      size="mini"
      row-id="roleID"
      border
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
      @cell-click="onCellClick"
    >
      <template v-slot:opt="{ row }">
        <i class="el-icon-delete tool-btn" @click="remove([row.roleID])" />
      </template>
      <template v-slot:roleName="{ row }"
        >{{ row.roleName }}
        <el-tag size="mini" :type="row.roleStatus === 1 ? 'light' : 'warning'">
          {{ row.v_roleStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [EditLoading, TableAutoHeight],
  components: {},
  props: { userCode: { type: String, default: '' } },
  data() {
    return {
      tableData: [],
      loading: false,
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'col-opt',
          align: 'center',
          fixed: 'left',
          width: 50,
          slots: { default: 'opt' },
        },
        {
          title: this.$l('table_label_roleName') || '角色名称',
          field: 'roleName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          slots: { default: 'roleName' },
        },
      ],
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    height() {
      const height = this.tableHeight - 250
      return height < 500 ? 500 : height
    },
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .sysUserRoleListApi({ userCode: this.userCode })
        .catch(() => null)
      this.loading = false
      const data = res?.body?.data || []

      this.tableData = data.filter((c) => c.permission === 'Y')
    },
    assignmentData(data) {
      this.tableData = data
    },
    clear() {
      const data = this.$refs.table.getCheckboxRecords()
      this.remove(data.map((m) => m.roleID))
    },

    async remove(roleIds) {
      roleIds.forEach((e) => {
        const index = this.tableData.findIndex((item) => item.roleID === e)
        this.tableData.splice(index, 1)
      })
      this.$emit('cancelCheck', roleIds)
    },

    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return
      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
    },
  },
}
</script>
